import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
const CheckoutPage = () => {
  const [checkoutMode, setCheckoutMode] = useState<'guest' | 'account'>('guest');
  const navigate = useNavigate();
  return <div className="container mx-auto px-4 py-8" data-id="element-88">
      <div className="max-w-4xl mx-auto" data-id="element-89">
        <div className="flex items-center mb-6" data-id="element-90">
          <button onClick={() => navigate('/booking')} className="text-gray-600 hover:text-teal-600 flex items-center" data-id="element-91">
            <ChevronLeftIcon className="h-5 w-5 mr-1" data-id="element-92" />
            Back to Booking
          </button>
        </div>
        <h1 className="text-3xl font-bold mb-8" data-id="element-93">Checkout</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-94">
          {/* Checkout Form */}
          <div className="md:col-span-2" data-id="element-95">
            {/* Checkout Options */}
            <div className="mb-6" data-id="element-96">
              <div className="flex border-b border-gray-200" data-id="element-97">
                <button onClick={() => setCheckoutMode('guest')} className={`py-3 px-4 font-medium ${checkoutMode === 'guest' ? 'text-teal-600 border-b-2 border-teal-600' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-98">
                  Guest Checkout
                </button>
                <button onClick={() => setCheckoutMode('account')} className={`py-3 px-4 font-medium ${checkoutMode === 'account' ? 'text-teal-600 border-b-2 border-teal-600' : 'text-gray-600 hover:text-gray-800'}`} data-id="element-99">
                  Create Account
                </button>
              </div>
            </div>
            {/* Contact Information */}
            <div className="mb-6" data-id="element-100">
              <h2 className="text-xl font-semibold mb-4" data-id="element-101">
                Contact Information
              </h2>
              <div className="space-y-4" data-id="element-102">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-103">
                  <div data-id="element-104">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-105">
                      First Name
                    </label>
                    <input type="text" id="firstName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-106" />
                  </div>
                  <div data-id="element-107">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-108">
                      Last Name
                    </label>
                    <input type="text" id="lastName" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-109" />
                  </div>
                </div>
                <div data-id="element-110">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-111">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-112" />
                </div>
                <div data-id="element-113">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-114">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-115" />
                </div>
              </div>
            </div>
            {/* Address */}
            <div className="mb-6" data-id="element-116">
              <h2 className="text-xl font-semibold mb-4" data-id="element-117">Address</h2>
              <div className="space-y-4" data-id="element-118">
                <div data-id="element-119">
                  <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-120">
                    Address
                  </label>
                  <input type="text" id="address" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-121" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-122">
                  <div data-id="element-123">
                    <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-124">
                      City
                    </label>
                    <input type="text" id="city" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-125" />
                  </div>
                  <div data-id="element-126">
                    <label htmlFor="postcode" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-127">
                      Postcode
                    </label>
                    <input type="text" id="postcode" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-128" />
                  </div>
                </div>
              </div>
            </div>
            {/* Password (only for account creation) */}
            {checkoutMode === 'account' && <div className="mb-6" data-id="element-129">
                <h2 className="text-xl font-semibold mb-4" data-id="element-130">Create Password</h2>
                <div className="space-y-4" data-id="element-131">
                  <div data-id="element-132">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-133">
                      Password
                    </label>
                    <input type="password" id="password" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-134" />
                  </div>
                  <div data-id="element-135">
                    <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-136">
                      Confirm Password
                    </label>
                    <input type="password" id="confirmPassword" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-137" />
                  </div>
                </div>
              </div>}
            {/* Payment Information */}
            <div className="mb-6" data-id="element-138">
              <h2 className="text-xl font-semibold mb-4" data-id="element-139">
                Payment Information
              </h2>
              <div className="space-y-4" data-id="element-140">
                <div data-id="element-141">
                  <label htmlFor="cardNumber" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-142">
                    Card Number
                  </label>
                  <input type="text" id="cardNumber" placeholder="•••• •••• •••• ••••" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-143" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-144">
                  <div data-id="element-145">
                    <label htmlFor="expiryDate" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-146">
                      Expiry Date
                    </label>
                    <input type="text" id="expiryDate" placeholder="MM/YY" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-147" />
                  </div>
                  <div data-id="element-148">
                    <label htmlFor="cvv" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-149">
                      CVV
                    </label>
                    <input type="text" id="cvv" placeholder="•••" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-150" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Order Summary */}
          <div className="md:col-span-1" data-id="element-151">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-152">
              <h2 className="text-xl font-semibold mb-4" data-id="element-153">Order Summary</h2>
              <div className="mb-4 pb-4 border-b border-gray-200" data-id="element-154">
                <h3 className="font-medium" data-id="element-155">Gel Manicure</h3>
                <p className="text-gray-600 text-sm" data-id="element-156">
                  60 mins with Sophie Chen
                </p>
                <div className="mt-2 flex justify-between" data-id="element-157">
                  <p className="text-gray-600" data-id="element-158">Date & Time</p>
                  <p className="font-medium" data-id="element-159">Jun 15, 2:00 PM</p>
                </div>
              </div>
              <div className="space-y-2 mb-4 pb-4 border-b border-gray-200" data-id="element-160">
                <div className="flex justify-between" data-id="element-161">
                  <p className="text-gray-600" data-id="element-162">Subtotal</p>
                  <p className="font-medium" data-id="element-163">£45.00</p>
                </div>
                <div className="flex justify-between" data-id="element-164">
                  <p className="text-gray-600" data-id="element-165">Travel Fee</p>
                  <p className="font-medium" data-id="element-166">£5.00</p>
                </div>
              </div>
              <div className="flex justify-between text-lg font-semibold" data-id="element-167">
                <p data-id="element-168">Total</p>
                <p data-id="element-169">£50.00</p>
              </div>
              <button className="w-full mt-6 bg-teal-600 text-white py-3 px-4 rounded-md hover:bg-teal-700 transition-colors" data-id="element-170">
                Complete Booking
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default CheckoutPage;